import { render, staticRenderFns } from "./TitleListSortingSwitcherSeo.vue?vue&type=template&id=248bd324"
import script from "./TitleListSortingSwitcherSeo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleListSortingSwitcherSeo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleListSortingSwitcherSeo.vue?vue&type=style&index=0&id=248bd324&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports